import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "center" }

import { ref, reactive } from 'vue' 
import { layer } from '@layui/layer-vue'
import {changePassword,getUser} from '../../api'
 



export default /*#__PURE__*/_defineComponent({
  __name: 'basicInfo',
  setup(__props) {

const user = reactive({
    userName: "",
    oldPassword: "",
    newpassword: "",
    password: "",

})

 const findUser=()=>{
    getUser().then((res: any) => {
        if (res!=""&&res.code == 0) {  
            user.userName=res.data.userName;
        }  
    })


 }
 findUser();


const submit2 = function () {
    
   if(user.password.length==0||user.oldPassword.length==0||user.newpassword.length==0){

    layer.msg("输入的密码错误！请重新输入。", { icon : 2, time: 1000})
    return
   }

   if(user.newpassword!=user.password){ 

    layer.msg("输入的新密码与确定密码不一致！请重新输入。", { icon : 2, time: 1000})
    return
   }
   
   changePassword(JSON.stringify(user)).then((res: any) => {
        if (res!=""&&res.code == 0) {  
            layer.msg("修改成功", { icon : 1, time: 1000})
           
        }  
    })

 
};


return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_panel = _resolveComponent("lay-panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_lay_panel, null, {
      default: _withCtx(() => [
        _createVNode(_component_lay_form, {
          model: user,
          pane: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_form_item, {
              label: "账户",
              prop: "userName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_input, {
                  modelValue: user.userName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.userName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_lay_form_item, {
              label: "旧密码",
              prop: "oldPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_input, {
                  modelValue: user.oldPassword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.oldPassword) = $event)),
                  type: "password"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_lay_form_item, {
              label: "新密码",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_input, {
                  modelValue: user.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.password) = $event)),
                  type: "password"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_lay_form_item, {
              label: "确定密码",
              prop: "newpassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_input, {
                  modelValue: user.newpassword,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.newpassword) = $event)),
                  type: "password"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_lay_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_button, {
                  type: "primary",
                  onClick: submit2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ]))
}
}

})